"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCyRoleAnchor = exports.dataCy = exports.MenuContext = exports.Menu = void 0;
var _react = require("react");
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _HoverMenu = _interopRequireDefault(require("material-ui-popup-state/HoverMenu"));
var _hooks = require("material-ui-popup-state/hooks");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["hover", "anchor", "open", "anchorEl", "onClose", "children", "anchorOrigin", "PaperProps", "style", "slotProps"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var dataCy = exports.dataCy = 'Menu';
var dataCyRoleAnchor = exports.dataCyRoleAnchor = 'menuAnchor';
var MenuContext = exports.MenuContext = /*#__PURE__*/(0, _react.createContext)({
  onItemClick: function onItemClick() {}
});
var _i = 0;

// TODO: replace with picker and remvoe

var Menu = exports.Menu = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var hover = _ref.hover,
    anchor = _ref.anchor,
    _open = _ref.open,
    _anchorEl = _ref.anchorEl,
    onClose = _ref.onClose,
    children = _ref.children,
    anchorOrigin = _ref.anchorOrigin,
    PaperProps = _ref.PaperProps,
    style = _ref.style,
    slotProps = _ref.slotProps,
    props = _objectWithoutProperties(_ref, _excluded);
  if (_open !== undefined || _anchorEl !== undefined) {
    /* eslint-disable */
    console.error('GgMenu is controlled, props open and anchorEl are omitted', {
      _open: _open,
      _anchorEl: _anchorEl
    });
    /* eslint-enable */
  }
  var MenuComponent = hover ? _HoverMenu["default"] : _Menu["default"];
  var _useState = (0, _react.useState)(function () {
      return "menu-".concat(_i++);
    }),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var popupState = (0, _hooks.usePopupState)({
    variant: 'popover',
    popupId: id
  });
  var menuAnchorProps = (hover ? _hooks.bindHover : _hooks.bindToggle)(popupState);
  var menuAnchor = anchor && (typeof anchor === 'function' ? anchor(_objectSpread({
    dataCyRole: dataCyRoleAnchor,
    open: popupState.isOpen
  }, menuAnchorProps)) : /*#__PURE__*/(0, _react.cloneElement)(anchor, _objectSpread(_objectSpread({
    'data-cy-role': dataCyRoleAnchor
  }, menuAnchorProps), {}, {
    onClick: function onClick(event) {
      var _menuAnchorProps$onCl, _anchor$props, _anchor$props$onClick;
      menuAnchorProps === null || menuAnchorProps === void 0 || (_menuAnchorProps$onCl = menuAnchorProps.onClick) === null || _menuAnchorProps$onCl === void 0 || _menuAnchorProps$onCl.call(menuAnchorProps, event);
      anchor === null || anchor === void 0 || (_anchor$props = anchor.props) === null || _anchor$props === void 0 || (_anchor$props$onClick = _anchor$props.onClick) === null || _anchor$props$onClick === void 0 || _anchor$props$onClick.call(_anchor$props, event);
    }
  })));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(MenuContext.Provider, {
    value: {
      onItemClick: popupState.close
    },
    children: [menuAnchor, /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuComponent, _objectSpread(_objectSpread(_objectSpread({
      anchorOrigin: _objectSpread({
        vertical: 'bottom',
        horizontal: 'left'
      }, anchorOrigin),
      ref: ref
    }, props), (0, _hooks.bindMenu)(popupState)), {}, {
      slotProps: _objectSpread(_objectSpread({}, slotProps), {}, {
        paper: _objectSpread(_objectSpread({
          'data-cy': dataCy
        }, PaperProps), slotProps === null || slotProps === void 0 ? void 0 : slotProps.paper)
      }),
      children: children
    }))]
  });
});
Menu.propTypes = {
  /**
   * The content of the table, normally TableHead and TableBody.
   */
  children: _propTypes["default"].node,
  anchor: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node])
};
var _default = exports["default"] = Menu;